import { useCandidateHeaderQuery } from "@generated/graphql";
import { useParams } from "react-router-dom";
import ExaminationList from "components/ExaminationList";
import qs from "qs";

const TrialList = () => {
  const { candidateId } = useParams();

  const { data: candidateData } = useCandidateHeaderQuery({ variables: { candidateId: candidateId! } });

  const permanentFilter = {
    candidateNumericId: candidateData?.companyCandidate?.numericId,
  };

  return (
    <ExaminationList
      storageName='candidateTesting'
      permanentFilter={permanentFilter}
      defaultVisibleColumnList={[
        "numericId",
        "competencyMapTitle",
        "competencesCount",
        "candidateNumericId",
        "candidate",
        "createdAt",
        "status",
        "type",
      ]}
      navigateSearch={qs.stringify({ candidateId })}
    />
  );
};

export default TrialList;
